module.exports = "/images/sg.svg?dd8fc1043efbdc3c38771afc9c036c42";